module.exports = __webpack_public_path__ + "assets/cue_coordinate.050f7ecf.svg";